import { Typography, Box, TextField, InputAdornment } from "@mui/material";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";

const CountrySelectionHeader = ({ title }: { title: string }) => {
    return (
        <Box
            py={2}
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            style={{ position: "sticky", top: -12, backgroundColor: "white", zIndex: 1 }}
        >
            <Typography variant="h3">{title}</Typography>
            <TextField
                size="small"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchTwoToneIcon />
                        </InputAdornment>
                    ),
                }}
                placeholder="Search..."
                sx={{
                    m: 1,
                }}
            />
        </Box>
    );
};

export default CountrySelectionHeader;
